import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import { InputField } from 'shared/ui/InputField';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Paper } from 'shared/ui/Paper';
import { Switch } from 'shared/ui/Switch';

interface Props {
	isEnable: boolean;
	toggleModel: () => void;
}

const NeuralModel: FC<Props> = ({ isEnable, toggleModel }) => {
	const { t } = useTranslation();

	return (
		<Paper
			sx={{
				paddingTop: '30px',
				paddingBottom: '30px',
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: '20px',
			}}
		>
			<Box sx={{ display: 'flex', gap: '20px' }}>
				<Switch
					checked={isEnable}
					name="neuralEnable"
					onChange={() => toggleModel()}
					sx={{ marginRight: '10px' }}
				/>
				<Typography variant={'h6'} color={ColorPalette.astronaut}>
					{t('custom_model.model_types.neural')}
				</Typography>
			</Box>

			<Box
				sx={{
					'width': '50%',
					'& > div': { margin: 0 },
				}}
			>
				<InputField
					name={'neuralLimit'}
					type="number"
					label={''}
					placeholder={t('auth.validation.enter_name')}
				/>
			</Box>
		</Paper>
	);
};

export default NeuralModel;
